import React from 'react';
import {Link} from "react-router-dom";
import './CSS/Footer.css';

import twitterlogo from '../Assets/Images/Twitter-White-100x100-1.png';
import facebooklogo from '../Assets/Images/Facebook-White-100x100-1.png';
import linkdenlogo from '../Assets/Images/LinkedIn-White-100x100-1.png';

function Footer() {
    return (
        <footer className="footer">
            <p>© Vize Labs Inc 2020</p>
            <div className="footer-links">
                <Link to="/about">Contact Us</Link>
                <Link to="/customer-support">Customer Support</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/terms-of-service">Terms of Service</Link>
            </div>
            <div className="social-icons">
                <a href="https://www.linkedin.com/company/vize-labs/" target="_blank" rel="noopener noreferrer">
                    <img src={linkdenlogo} alt="LinkedIn"/>
                </a>
                <a href="https://www.facebook.com/VizeLabs" target="_blank" rel="noopener noreferrer">
                    <img src={facebooklogo} alt="Facebook"/>
                </a>
                <a href="https://x.com/LabsVize" target="_blank" rel="noopener noreferrer">
                    <img src={twitterlogo} alt="Twitter"/>
                </a>
            </div>
        </footer>
    );
}

export default Footer;
